<template>
  <v-dialog v-model="dialog" persistent max-width="480">
    <v-card>
      <v-form @submit.prevent="confirm()">
        <v-card-title class="headline grey lighten-2">
          Confirm same passenger top-up
        </v-card-title>
        <v-card-text class="pt-4">
          <p>
            You already topped up <strong>{{ phoneNumber }}</strong> within the last hour.
            Type <strong>yes</strong> to confirm you want to add <strong>{{ amountLabel }}</strong> to this passenger again.
          </p>
          <v-text-field
            ref="yesField"
            v-model="confirmationText"
            label='Type "yes" to confirm'
            autocomplete="off"
            autofocus
          />
        </v-card-text>
        <v-card-actions>
          <v-btn text color="warning" @click="cancel()">Cancel</v-btn>
          <v-spacer />
          <v-btn type="submit" color="primary" :disabled="!canConfirm">
            Confirm top-up
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import src from './src'
export default src
</script>
